import { default as zingchart } from './zingchart-es6.min.js';
var ZC = window.ZC;
export { zingchart as default, ZC };